/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { EmailFieldItemEdit } from "./edit-item";

const EmailFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <EmailFieldItemEdit />
        </FieldListEditWrapper>
    );
};
EmailFieldEdit.displayName = "EmailFieldEdit";
export { EmailFieldEdit };
